import { initDeferredSentry, initLazyChromeGlightbox } from './lib/lazy-chrome-deps';

initDeferredSentry();
initLazyChromeGlightbox();

var fly_events: LegacyModule = {
	init: function () {
		this.events();
	},

	throttle: function (type, name, obj) {
		obj = obj || window;
		var running = false;
		var func = function () {
			if (running) {
				return;
			}
			running = true;
			requestAnimationFrame(function () {
				var event = document.createEvent('Event');
				event.initEvent(name, false, true);
				obj.dispatchEvent(event);
				//obj.dispatchEvent(new CustomEvent(name));
				running = false;
			});
		};
		const passive = type === 'scroll' ? { passive: true } : false;
		obj.addEventListener(type, func, passive);
	},

	events: function () {
		this.throttle('resize', 'optimizedResize');
		this.throttle('scroll', 'optimizedScroll', document);
	},
};
fly_events.init();

var fly_global: LegacyModule = {
	init: function () {
		this.cache();
		this.events();
	},

	cache: function () {
		this.$fbShareLinks = document.querySelectorAll('.fbShare');
	},

	events: function () {
		for (var i = this.$fbShareLinks.length - 1; i >= 0; i--) {
			this.$fbShareLinks[i].addEventListener('click', this.fbShare.bind(this));
		}
	},

	fbShare: function (e) {
		var target = e.currentTarget;
		var url = target.getAttribute('data-url');
		FB.ui(
			{
				method: 'share',
				href: url,
			},
			function (_response) {}
		);
	},
};
fly_global.init();

var fly_chrome: LegacyModule = {
	accordion_active: true,
	old_w: window.innerWidth,

	init: function () {
		this.cache();
		this.events();
	},

	cache: function () {
		this.$f_nav_els = document.querySelectorAll('.siteFooter .js-accordionHeader');
	},

	events: function () {
		for (var i = 0; i < this.$f_nav_els.length; i++) {
			this.$f_nav_els[i].addEventListener('click', this.toggle.bind(this));
		}
		window.addEventListener('optimizedResize', this.check_accordion.bind(this));
	},

	//remove accordion classes and styles when resizing up
	check_accordion: function () {
		this.new_w = window.innerWidth;
		if (this.new_w !== this.old_w && this.new_w >= 768 && this.accordion_active) {
			this.accordion_active = false;
			this.collapse_all();
		}
		this.old_w = this.new_w;
	},

	toggle: function (e) {
		e.preventDefault();
		var $targ = e.currentTarget;
		var $wrap = $targ.parentNode.querySelector('.js-accordionContent');
		var $menu = $wrap.querySelector('.menu');
		var menu_h = $menu.clientHeight;

		if ($targ.classList.contains('active')) {
			this.accordion_active = false;
			$targ.classList.remove('active');
			$wrap.removeAttribute('style');
		} else {
			this.accordion_active = true;
			this.collapse_all();
			$targ.classList.add('active');
			$wrap.style.height = menu_h + 'px';
			$wrap.style.opacity = 1;
		}
	},

	collapse_all: function () {
		for (var i = 0; i < this.$f_nav_els.length; i++) {
			var $targ = this.$f_nav_els[i];
			var $wrap = $targ.parentNode.querySelector('.js-accordionContent');
			$targ.classList.remove('active');
			$wrap.removeAttribute('style');
		}
	},
};

fly_chrome.init();

var ff_header_mobile_nav: LegacyModule = {
	scroll_disable_checked: false,

	init: function () {
		this.cache();
		this.events();
	},

	cache: function () {
		this.$underlay = document.getElementById('ff-menu-underlay');
		this.$tier_3_trigger = document.querySelector('.tier3MobileMenuTrigger');
		this.$tier_3_menu = document.querySelector('.tier3Menu .tier3MobileMenuContent');
		this.$tier_3_menu_inner = document.querySelector('.tier3Menu .tier3MobileMenuContent .inner');

		// this.$mobile_trigger = document.getElementById('ff-icon-mobile-menu');
		// this.$mobile_menu = document.getElementById('ff-menu-mobile');
	},

	events: function () {
		if (this.$tier_3_trigger) {
			this.$tier_3_trigger.addEventListener('click', this.tier_3_toggle.bind(this));
		}
	},

	close_menu_collateral: function () {
		document.body.classList.remove('scroll-disabled');
		this.$underlay.classList.remove('ff-active');
	},

	open_menu_collateral: function () {
		document.body.classList.add('scroll-disabled');
		this.scroll_disable_checked = false;
		this.$underlay.classList.add('ff-active');
	},

	close_tier_3: function () {
		this.$tier_3_trigger.classList.remove('active');
		this.$tier_3_menu.classList.remove('active');
		this.$tier_3_menu.style.height = 0;
	},

	open_tier_3: function () {
		var h = this.$tier_3_menu_inner.clientHeight;
		this.$tier_3_trigger.classList.add('active');
		this.$tier_3_menu.classList.add('active');
		this.$tier_3_menu.style.height = h + 'px';
	},

	tier_3_toggle: function (e) {
		e.preventDefault();

		if (this.$tier_3_trigger.classList.contains('active')) {
			//this.close_menu_collateral();
			this.close_tier_3();
		} else {
			//this.open_menu_collateral();
			this.open_tier_3();
		}
	},

	close_mobile: function () {
		this.$mobile_trigger.classList.remove('ff-active');
		this.$mobile_menu.classList.remove('ff-active');
	},

	open_mobile: function () {
		this.$mobile_trigger.classList.add('ff-active');
		this.$mobile_menu.classList.add('ff-active');
	},

	mobile_toggle: function (e) {
		e.preventDefault();

		if (this.$mobile_trigger.classList.contains('ff-active')) {
			this.close_menu_collateral();
			this.close_mobile();
		} else {
			this.open_menu_collateral();
			this.open_mobile();
			if (this.$tier_3_trigger) {
				this.close_tier_3();
			}
		}
	},

	close_menus: function () {
		this.close_menu_collateral();
		this.close_mobile();
		if (this.$tier_3_trigger) {
			this.close_tier_3();
		}
	},
};
ff_header_mobile_nav.init();

class FFHeaderNewsletter {
	DOM = {} as Record<string, any>;

	constructor() {
		this.cache();
		this.events();
	}

	cache() {
		this.DOM = {
			panels: document.querySelectorAll('.js-navSubscribe'),
		};
	}

	events() {
		for (var i = 0; i < this.DOM.panels.length; i++) {
			this.DOM.panels[i]
				.querySelector('.js-cta')
				.addEventListener('click', this.ctaClick.bind(this));
			this.DOM.panels[i]
				.querySelector('.js-form')
				.addEventListener('submit', this.formSubmit.bind(this));
		}
	}

	ctaClick() {
		this.updatePanelState('active');
	}

	formSubmit(e) {
		e.preventDefault();

		var data = this.getData(e.currentTarget);

		fetch('https://nw3s7sees2.execute-api.us-west-2.amazonaws.com/Prod/subscribe', {
			method: 'POST',
			body: JSON.stringify(data),
			headers: {
				'Content-type': 'application/json; charset=UTF-8',
			},
		}).then(this.submissionResponse.bind(this));
	}

	getData(form) {
		return {
			email: form.querySelector('input[name="EMAIL"]').value,
			honorific: form.querySelector('input[name="honorific"]').value,
		};
	}

	submissionResponse(response) {
		//success
		if (response.status === 200) {
			this.updatePanelState('success');
		}
	}

	updatePanelState(state) {
		for (var i = 0; i < this.DOM.panels.length; i++) {
			this.DOM.panels[i].classList.remove('resting', 'active', 'success');
			this.DOM.panels[i].classList.add(state);
		}
	}
}
new FFHeaderNewsletter();

class FFNewsletter {
	constructor() {
		document.querySelectorAll<HTMLFormElement>('.js-newsletterForm').forEach((form) => {
			form.addEventListener('submit', (event) => {
				this.formSubmit(event, form);
			});
		});
	}

	formSubmit(e: Event, form: HTMLFormElement) {
		e.preventDefault();

		const email = form.querySelector<HTMLInputElement>('input[name="EMAIL"]');
		const honorific = form.querySelector<HTMLInputElement>('input[name="honorific"]');
		if (!email) return;

		const data = {
			email: email.value,
			honorific: honorific ? honorific.value : '',
		};

		fetch('https://nw3s7sees2.execute-api.us-west-2.amazonaws.com/Prod/subscribe', {
			method: 'POST',
			body: JSON.stringify(data),
			headers: {
				'Content-type': 'application/json; charset=UTF-8',
			},
		})
			.then((response) => {
				if (response.status === 200) {
					form.innerHTML = '<p class="success">Nice! You&rsquo;re all set.</p>';
				}
			})
			.catch(() => {
				form.innerHTML =
					'<p class="error">Unable to subscribe right now. Please try again later.</p>';
			});
	}
}
new FFNewsletter();

var _ff_ga: LegacyModule = {
	init: function () {},
	cache: function () {},
	send_ev: function (e) {
		//e.preventDefault();
		const $el = e.currentTarget as HTMLAnchorElement;
		ga('send', 'event', {
			eventCategory: $el.getAttribute('data-cat'),
			eventAction: 'click',
			eventLabel: $el.getAttribute('data-label'),
			hitCallback: function () {
				window.location.href = $el.href;
			},
		});
	},
};
